import LandingHeroSection from "./components/LandingHeroSection";
import LandingAbout from "./components/LandingAbout";
import Features from "./components/Features";
import JoinAgnt from "./components/JoinAgnt";
import Ecosystem from "./components/Ecosystem";
import AttentionFlywheel from "./components/AttentionFlywheel";

const LandingPageContent = () => {
  return (
    <>
      <LandingHeroSection />
      <LandingAbout />
      <Features />
      <AttentionFlywheel />
      <Ecosystem />
      <JoinAgnt />
    </>
  );
};

export default LandingPageContent;
